<!-- 三方单位操作 -->
<template>
  <div>
    <div v-if="isLoaded">
      <div class="demo-drawer__content data_action_form">
        <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="formDataList">
          <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="formDataList" @tabs="(val)=>{showTabs=val}">
            <template slot="tabs" slot-scope="scope">
              <div class="table_content_box">
                <!-- 主信息 -->
                <div v-if="scope.index == 0">
                  <el-form label-width="120px" label-position="right" size="mini" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" :disabled="dataActionBox.actionType>1" :show-message="false">
                    <el-row>
                      <el-form-item :label="formOneValue.showField" :prop="formOneValue.entityField" v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey" v-if="formOneValue.isShow==1" :rules="formOneValue.isRequired == 1 ? [{required: true, trigger: ['blur', 'change']}] : []">
                        <!-- 系统字段 -->
                        <div v-if="formOneValue.isReserved == 0">
                          <el-input v-if="formOneValue.fieldType == 'search'" v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength" @focus="openSearch(formOneValue.searchId, formOneValue.entityField, formOneValue.setField)" :disabled="formOneValue.isChange==0" clearable>
                            <el-button @click="openSearch(formOneValue.searchId, formOneValue.entityField,formOneValue.setField)" slot="append" icon="el-icon-search"></el-button>
                          </el-input>
                          <df-date :isdisabled="formOneValue.isChange == 0" v-else-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                          <el-input v-else-if="formOneValue.entityField == 'vrRemark'" type="textarea" v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength" :disabled="formOneValue.isChange==0" clearable>
                          </el-input>
                          <el-input v-else v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength" :disabled="formOneValue.isChange==0" clearable></el-input>
                        </div>
                        <!-- 扩展字段 -->
                        <div v-if="formOneValue.isReserved == 1">
                          <!-- 自填 -->
                          <el-input v-model.trim="sendDataInfo[formOneValue.entityField]" v-if="formOneValue.operatType == 0" :maxlength="$store.state.inputLength" :disabled="formOneValue.isChange==0" clearable></el-input>
                          <!-- 选择数据来源 -->
                          <el-input v-model.trim="sendDataInfo[formOneValue.entityField]" v-else :maxlength="$store.state.inputLength" :disabled="formOneValue.isChange==0" clearable></el-input>
                        </div>
                      </el-form-item>
                    </el-row>

                  </el-form>
                </div>

              </div>
            </template>
          </v-tabs>
        </el-card>
        <div class="foots">
          <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary" @click="showPrintPlan">打印</el-button>
          <el-button type="primary" @click="initActionBox" v-if="dataActionBox.actionType!=2">取消</el-button>
          <el-button type="primary" @click="sendDataAction()" v-if="dataActionBox.actionType==0">保存</el-button>
          <el-button type="primary" @click="sendDataAction()" v-if="dataActionBox.actionType==1">保存</el-button>
          <!-- <el-button type="primary" v-if="dataActionBox.actionType==3" @click="submitData()">提交供货商</el-button> -->
        </div>
      </div>
    </div>
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
      <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" />
    </el-dialog>
    <printPlan ref="printPlan"></printPlan>
  </div>
</template>

<script>
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
  name: "thirdPartyUnitAction",
  props: ["actionData"],
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
  },
  data() {
    //这里存放数据
    return {
      dataActionBox: {
        showStatus: false,
        openMode: "ltr" || "rtl",
        boxTitle: "新增" || "编辑",
        actionType: 0, // 0新增，1修改
      },
      isLoaded: false,
      showTabs: "",
      formDataList: [],
      sendDataInfo: {
        address: "",	//	地址
        linker: "",	//	名称
        telnumber: "",	//	电话
        remark: "",	//	备注
        unitId: "",	//	
        unitName: "",	//	名称
      },
      DialogVisible: false,
      seTitle: "",
      seWidth: "",
      seType: "",
      sField: "",
      parentSearchData: {},

    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //检索方案
    openSearch(sId, type, sField) {
      this.DialogVisible = true;
      this.seId = sId;
      this.seType = type;
      this.sField = sField;
      this.parentSearchData[type] = this.sendDataInfo[type];
    },
    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(',')
      arr.forEach(item => {
        this.sendDataInfo[item] = val[item]
      })
    },
    //检索返回
    changeInputModel(val) {
      console.log('changeInputModel', val);
      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        this.paramValue(val)
      }
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },
    showPrintPlan() {
      // 打印方法
      // 调用全局方法 判断Websocket是否连接
      if (this.$printSocketApi.printExeMsg() != false) {
        // 选中的数据
        this.$refs.printPlan.openDia(
          this.actionData.orderId,
          this.actionData.printSouce,
          this.actionData.printJurId
        );
      } else {
        return;
      }
    },

    //保存
    async sendDataAction() {
      let flag = false;
      this.$refs["sendDataInfo"].validate((valid) => {
        if (valid) {
        } else {
          this.$message({
            message: "请完善证照信息表单的必填信息",
            type: "error",
          });
          flag = true;
          return false;
        }
      });
      let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
      let responseData;

      if (this.dataActionBox.actionType == 0) {
        responseData = await this.$http.descibUnitAdd(sendData);
      } else if (this.dataActionBox.actionType == 1) {
        responseData = await this.$http.descibUnitUpdate(sendData);
      }
      if (responseData.status == 200) {
        this.$emit("drawerCancel", true);
        this.$refs["sendDataInfo"].resetFields();
        this.init();
        this.$message({
          message: "操作成功",
          type: "success",
        });
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },

    //取消新增
    initActionBox() {
          this.$emit("drawerCancel");
    },

    //初始化
    init() {
      for (const key in this.sendDataInfo) {
        this.sendDataInfo[key] = "";
      }
      this.dataActionBox.boxTitle = "";
    },

    //父级传入 获取列表
    openBox() {
      //   console.log("===", this.actionData);
      this.dataActionBox.actionType = this.actionData.cate;
      this.formDataList = this.actionData.formData;
      var oldData = this.actionData.oldData;
      this.showTabs = this.actionData.formData[0].jciName;
      this.formDataList.forEach(item => {
        item.isShowForm = 0
      })
      this.init();
      this.dataActionBox.showStatus = true;
      if (this.dataActionBox.actionType == 0) {
        this.dataActionBox.boxTitle = "新增三方单位";
        this.dataActionBox.openMode = "ltr";
      } else {
        if (this.dataActionBox.actionType == 1) {
          this.dataActionBox.boxTitle = "修改三方单位";
          this.dataActionBox.openMode = "rtl";
          this.sendDataInfo = oldData;
        } else if (this.dataActionBox.actionType == 2) {
          this.dataActionBox.boxTitle = "查看信息";
          var dataInfo = JSON.parse(JSON.stringify(oldData));
          for (let key in dataInfo) {
            this.sendDataInfo[key] = dataInfo[key];
            if (
              key == "smManrange" ||
              key == "smProrange" ||
              key == "smTrerange"
            ) {
              this.sendDataInfo[key] = dataInfo[key] ? dataInfo[key].toString() : ""
            }
          }
        } else {
          this.sendDataInfo = oldData;
          this.dataActionBox.boxTitle = "信息审核";
        }
        this.sendDataInfo.smIntype = Number(oldData.smIntype);
        console.log(this.sendDataInfo.smManrange);
      }
    },

  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.$nextTick(() => {
      this.openBox();
      this.isLoaded = true;
    });
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.baseForm .el-row {
  display: flex;
  flex-wrap: wrap;
}
</style>
